import "core-js/modules/es6.string.small";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import withProps from 'recompose/withProps';
import React, { Component } from 'react';
import IconDanger from "../Icon/IconDanger";
import IconSuccess from "../Icon/IconSuccess";
import IconWarning from "../Icon/IconWarning";
import { pxToEm } from "../styles";
import IconArrowDropdownUp from "../Icon/IconArrowDropdownUp";
import IconArrowDropdownDown from "../Icon/IconArrowDropdownDown";
import { SelectTriggerRoot as Root, Trigger, TriggerContent } from "./styled";
import { SIZE } from "./constants";
var variantIcons = {
  danger: ___EmotionJSX(IconDanger, null),
  success: ___EmotionJSX(IconSuccess, null),
  warning: ___EmotionJSX(IconWarning, null)
};
var iconMarginMap = {
  small: 4,
  medium: 8,
  large: 8,
  jumbo: 14
};

var stopPropagation = function stopPropagation(event) {
  return event.stopPropagation();
};

var SelectTrigger =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SelectTrigger, _Component);

  function SelectTrigger() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SelectTrigger.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        isOpen = _this$props.isOpen,
        item = _this$props.item,
        name = _this$props.name,
        placeholder = _this$props.placeholder,
        readOnly = _this$props.readOnly,
        triggerRef = _this$props.triggerRef,
        _this$props$size = _this$props.size,
        size = _this$props$size === void 0 ? SIZE.large : _this$props$size,
        variant = _this$props.variant,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["disabled", "isOpen", "item", "name", "placeholder", "readOnly", "triggerRef", "size", "variant"]);

    var ArrowIcon = isOpen ? IconArrowDropdownUp : IconArrowDropdownDown;
    var Arrow = withProps({
      size: size === SIZE.small || size === SIZE.medium ? SIZE.medium : pxToEm(24)
    })(
    /*#__PURE__*/
    _styled(ArrowIcon, {
      target: "e7c9dyg0"
    })({
      margin: pxToEm(iconMarginMap[size])
    }));
    var controlProps = {
      hasPlaceholder: !item,
      variant: item && item.variant
    };
    var inputProps = {
      name: name,
      onClick: stopPropagation,
      // Stop extra click Event in Edge from closing Select
      type: 'hidden',
      value: item ? item.value : ''
    };

    var rootProps = _objectSpread({
      afterItems: [___EmotionJSX(Arrow, {
        key: "arrow"
      }), ___EmotionJSX("input", _extends({}, inputProps, {
        key: "input"
      }))],
      control: Trigger,
      controlProps: controlProps,
      disabled: disabled,
      fauxControlRef: triggerRef,
      readOnly: readOnly,
      selectedItemVariant: item && item.variant,
      size: size,
      variant: variant
    }, restProps);

    if (item) {
      var iconEnd = item.iconEnd,
          iconStart = item.iconStart,
          _variant = item.variant;
      rootProps = _objectSpread({}, rootProps, {
        iconEnd: iconEnd,
        iconStart: _variant ? variantIcons[_variant] : iconStart,
        item: item,
        variant: this.props.variant
      });
    }

    return ___EmotionJSX(Root, rootProps, ___EmotionJSX(TriggerContent, null, item ? item.text : placeholder));
  };

  return SelectTrigger;
}(Component);

_defineProperty(SelectTrigger, "displayName", 'SelectTrigger');

export { SelectTrigger as default };